// const BaseURL = "http://localhost:8082/"
const BaseURL = "https://vcart-backend.onrender.com/"
export default BaseURL;